import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from 'react-i18next';

const responsive = {

  desktop: {
    breakpoint: { max: 3000, min: 1250 },
    items: 4,
  },
  littleweb: {
    breakpoint: { max: 1250, min: 1040 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1040, min: 630 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 630, min: 0 },
    items: 1
  }
};


// else {
//     history.push('/market')
// }


// Because this is an inframe, so the SSR mode doesn't not do well here.
// It will work on real devices.
const Swapcard = (props) => {
  const { t } = useTranslation()
  return (
    <Carousel
      swipeable={true}
      draggable={true}
      autoPlay={false}
      infinite={true}
      renderDotsOutside={true}
      ssr
      partialVisbile
      itemClass="image-item"
      responsive={responsive}
    //removeArrowOnDeviceType={["littleweb","tablet", "mobile"]}
    >
      {props.data.map(item => {
        // console.log(item)
        return (
          <div className="swapcard">
            <a href={`/market/Detail?serviceId=${item?.service_id}`}>
              <div className="basecard">
                <div className="cardlayoutA" style={{ padding: "20px", width: "100%", height: "100%" }}>
                  <div style={{ height: "20%", aspectRatio: "1/1", display: "flex", border: "solid 0.5px #C7C7C740" }}>
                    <img alt="icon" src={item?.icon_url} style={{ width: "100%", margin: "auto" }} />
                  </div>
                  <div style={{ width: "100%", height: "5%" }} />
                  <div style={{ color: "#7D7D7D", width: "100%", height: "20%", fontSize: "26px", lineHeight: "1.2" }}>
                    {localStorage.getItem('lang') === "tw" ? item?.service_info_data_tw?.[0]?.service_name : item?.service_info_data_en?.[0]?.service_name}
                  </div>
                  <div style={{ width: "100%", height: "10%", color: '#C7C7C7' }}>
                    {localStorage.getItem('lang') === 'en' ? `${t('Subscription.Card.by')} ${item?.vendor_name_en}` : `${t('Subscription.Card.by')} ${item?.vendor_name_tw}`}
                  </div>
                  <div style={{ width: "100%", height: "5%" }} />
                  <div style={{ width: "100%", height: "32%", color: '#7C7C7C', overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "6", WebkitBoxOrient: "vertical" }}>
                    {localStorage.getItem('lang') === "tw" ? item?.service_info_data_tw?.[0]?.summary : item?.service_info_data_en?.[0]?.summary}
                  </div>
                  <div style={{ width: "100%", height: "3%" }} />
                  <div style={{ width: "100%", height: "5%", color: "#7DB926", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "1", WebkitBoxOrient: "vertical" }}>
                    {`#${localStorage.getItem('lang') === 'en' ? item?.service_type_en : item?.service_type_tw}`}
                  </div>
                </div>
              </div>
            </a>
          </div>
        );
      })}
    </Carousel>
  );
};

export default Swapcard;
